var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRadioDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 1.99805C17.5233 1.99805 22.0011 6.47589 22.0011 11.9996C22.0011 17.5233 17.5233 22.0011 11.9996 22.0011C6.47589 22.0011 1.99805 17.5233 1.99805 11.9996C1.99805 6.47589 6.47589 1.99805 11.9996 1.99805ZM11.9996 3.49805C7.30432 3.49805 3.49805 7.30432 3.49805 11.9996C3.49805 16.6949 7.30432 20.5011 11.9996 20.5011C16.6949 20.5011 20.5011 16.6949 20.5011 11.9996C20.5011 7.30432 16.6949 3.49805 11.9996 3.49805ZM11.9962 5.99805C15.3088 5.99805 17.9943 8.68349 17.9943 11.9962C17.9943 15.3088 15.3088 17.9943 11.9962 17.9943C8.68349 17.9943 5.99805 15.3088 5.99805 11.9962C5.99805 8.68349 8.68349 5.99805 11.9962 5.99805Z",
    fill: "#AEB7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadioDisabled);
export default __webpack_public_path__ + "static/media/icon-radio-disabled.957c5cdfa5a111d9d3b54a59acbe15b7.svg";
export { ForwardRef as ReactComponent };